import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";
import { MunicipalPropertyYearQuery } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { DEFAULT_STALE_TIME_MS } from "@/services/react-query.service/stale-time";
import { useQuery,UseQueryResult } from "@tanstack/react-query";

import { MUNICIPAL_PROPERTY_YEAR_QUERY_DOCUMENT } from "./municipal-property-year-query.gql";

export const useMunicipalPropertyYear = (
  id: string,
  inventoryId?: string,
): UseQueryResult<MunicipalPropertyYearQuery["municipalPropertyYear"], Error> => {
  const { currentWorkspace }: ReturnType<typeof useCurrentWorkspaceContext> = useCurrentWorkspaceContext();
  return useQuery({
    queryKey: queryKeys.municipalPropertyYears.detail({ id, inventoryId }),
    queryFn: async (): Promise<MunicipalPropertyYearQuery["municipalPropertyYear"]> => {
      const response: MunicipalPropertyYearQuery = await createOperationClient("MunicipalPropertyYear").request(
        MUNICIPAL_PROPERTY_YEAR_QUERY_DOCUMENT,
        { id, inventoryId },
      );
      return response.municipalPropertyYear;
    },
    enabled: !!id,
    staleTime: DEFAULT_STALE_TIME_MS,
    meta: { workspaceId: currentWorkspace.id },
  });
};
